import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const StorytellingVideo = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedAge = searchParams.get('age') || '6-8';
  const language = searchParams.get('language') || 'farsi';

  const handleBack = () => {
    const hubPath = language === 'english' ? '/dashboard/learning-hub-english' : '/dashboard/learning-hub-farsi';
    navigate(`${hubPath}?age=${selectedAge}`);
  };

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      fontFamily: "'Nunito', sans-serif",
      backgroundColor: '#F4ABBA',
      color: '#333',
      paddingTop: '80px'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '30px',
          flexWrap: 'wrap',
          gap: '15px'
        }}>
          <h2 style={{
            fontSize: 'clamp(36px, 4vw, 48px)',
            fontWeight: '700',
            fontFamily: "'Fredoka', sans-serif",
            color: '#DD2E44',
            margin: 0
          }}>
            📖 Storytelling Videos
          </h2>
          <button
            onClick={handleBack}
            style={{
              backgroundColor: '#FFF5F7',
              color: '#DD2E44',
              padding: '10px 20px',
              borderRadius: '15px',
              border: '2px solid #DD2E44',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              fontFamily: "'Fredoka', sans-serif"
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#DD2E44';
              e.target.style.color = '#FFF5F7';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#FFF5F7';
              e.target.style.color = '#DD2E44';
            }}
          >
            ← Back
          </button>
        </div>

        {/* Video Containers */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '30px',
          maxWidth: '1000px',
          margin: '0 auto 40px'
        }}>
          {/* First Video */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '30px',
            boxShadow: '0 8px 30px rgba(221, 46, 68, 0.2)'
          }}>
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden',
              borderRadius: '15px',
              backgroundColor: '#000',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
            }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                src="https://www.youtube.com/embed/D3NmaAm-t44"
                title="Storytelling Video 1"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Second Video */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '30px',
            boxShadow: '0 8px 30px rgba(221, 46, 68, 0.2)'
          }}>
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden',
              borderRadius: '15px',
              backgroundColor: '#000',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
            }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                src="https://www.youtube.com/embed/ay2aCDrlqD0"
                title="Storytelling Video 2"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Third Video */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '30px',
            boxShadow: '0 8px 30px rgba(221, 46, 68, 0.2)'
          }}>
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden',
              borderRadius: '15px',
              backgroundColor: '#000',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
            }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                src="https://www.youtube.com/embed/gsxH07QHeoY"
                title="Storytelling Video 3"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>

          {/* Fourth Video */}
          <div style={{
            backgroundColor: 'white',
            borderRadius: '20px',
            padding: '30px',
            boxShadow: '0 8px 30px rgba(221, 46, 68, 0.2)'
          }}>
            <div style={{
              position: 'relative',
              paddingBottom: '56.25%', // 16:9 aspect ratio
              height: 0,
              overflow: 'hidden',
              borderRadius: '15px',
              backgroundColor: '#000',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.3)'
            }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                src="https://www.youtube.com/embed/HEZUj7_Fd2U"
                title="Storytelling Video 4"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorytellingVideo;
